<button class="hint-chip__chip d-inline-flex align-items-center gap-1 mat-font-body-sm"
        [matMenuTriggerFor]="menu">
  <mat-icon class="mat-icon-sm mat-text-primary">place</mat-icon>
  <span class="hint-chip__label">{{ label() }}</span>
  <mat-icon class="mat-icon-sm mat-text-on-surface-variant">arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu">
  @if (bbox()) {
    <button mat-menu-item (click)="zoomTo()">
      <mat-icon>zoom_out_map</mat-icon><span>Zoom to</span>
    </button>
  }
  @if (center()) {
    <button mat-menu-item (click)="moveTo()">
      <mat-icon>my_location</mat-icon><span>Center</span>
    </button>
  }
  @if (canCopy()) {
    <button mat-menu-item (click)="copy()">
      <mat-icon>content_copy</mat-icon><span>Copy address</span>
    </button>
  }
  <button mat-menu-item (click)="viewData()" [disabled]="loadingView()">
    <mat-icon>data_object</mat-icon>
    <span>{{ loadingView() ? 'Loading…' : 'View data' }}</span>
  </button>
</mat-menu>
